import React, { useEffect, useState } from 'react';
import {
	ButtonBlockPrimary,
	FormGroup,
	InputDate,
	InputPhoneNumber,
	InputText,
	InputTextArea,
	InputTextIcon,
	InputTextblock,
	Layout,
	RadioButton,
	SelectDropDown,
} from '../../../components';
import { Tusers, initialUsers } from '../../../type/users';
import { getMyProfile, updateMyProfile } from '../../../service/usersService';
import { Toption, initialOption } from '../../../type/option';
import {
	getCity,
	getDistrict,
	getProvinsi,
} from '../../../service/locationService';
import { Tprovinsi } from '../../../type/provinsi';
import { Tcity } from '../../../type/city';
import { Tdistrict } from '../../../type/district';
import { useNavigate } from 'react-router-dom';
import { showMessage } from '../../../utls/message';
import { isValidPhoneNumber } from 'react-phone-number-input';
import { getMaritalStatus } from '../../../service/maritalStatus';
import { TmaritalStatus } from '../../../type/maritalStatus';

const EditProfile = () => {
	const [showPassword, setShowPassword] = useState<boolean>(false);
	const [users, setUsers] = useState(initialUsers);
	const [fullName, setFullName] = useState(users.fullName);
	const [gender, setGender] = useState(users.gender);
	const [birthDate, setBirthDate] = useState<Date>(new Date());
	const [placeOfBirth, setPlaceOfBirth] = useState(users.placeOfBirth);
	const [maritalStatusList, setMaritalStatusList] = useState<Toption[]>([]);
	const [provinsiList, setProvinsiList] = useState<Toption[]>([]);
	const [selectProvinsi, setSelectProvinsi] = useState<Toption>(initialOption);
	const [selectMaritalStatus, setSelectMaritalStatus] =
		useState<Toption>(initialOption);
	const [cityList, setCityList] = useState<Toption[]>([]);
	const [selectCity, setSelectCity] = useState<Toption>(initialOption);
	const [districtList, setDistrictList] = useState<Toption[]>([]);
	const [selectDistrict, setSelectDistrict] = useState<Toption>(initialOption);
	const [address1, setAddress1] = useState(users.address1);
	const [address2, setAddress2] = useState(users.address2);
	const [email, setEmail] = useState(users.email);
	const [password, setPassword] = useState('');
	const [phone, setPhone] = useState(users.phone || '');

	const handleGenderChange = (value: string) => {
		setGender(value);
	};

	const navigate = useNavigate();

	const getMyDataProfile = async () => {
		const response = await getMyProfile();
		if (!response?.error) {
			setUsers(response?.data);
			const data: Tusers = response?.data;
			setFullName(data.fullName);
			setBirthDate(new Date(data.birthDate));
			setGender(data.gender);
			setPlaceOfBirth(data.placeOfBirth);
			if (data.maritalStatus) {
				setSelectMaritalStatus({
					label: data.maritalStatus.name,
					value: data.maritalStatus.id?.toString() || '0',
					data: data?.maritalStatus,
				});
			}
			if (data.provinsi) {
				setSelectProvinsi({
					label: data.provinsi.provinsiName,
					value: data.provinsi?.id?.toString() || '0',
					data: data.provinsi,
				});
			}
			if (data.city) {
				setSelectCity({
					label: data.city.cityName,
					value: data.city.id?.toString() || '0',
					data: data.city,
				});
			}
			if (data.district) {
				setSelectDistrict({
					label: data.district.districtName,
					value: data.district.id?.toString() || '0',
					data: data.district,
				});
			}
			setAddress1(data.address1);
			setAddress2(data.address2);
			setEmail(data.email);
			setPhone(data.phone || '');
		}
	};

	const getDataMaritalStatus = async (keyword: string) => {
		const data = {
			pageNo: 0,
			pageSize: 10,
			sortType: 'DESC',
			filter: [
				{
					key: 'name',
					value: keyword,
					operation: 'MATCH',
					conjunction: 'and',
				},
				{
					key: 'active',
					value: true,
					operation: 'EQUAL',
					conjunction: 'and',
				},
			],
		};
		const response = await getMaritalStatus(data);
		if (!response?.error) {
			const items: Toption[] = [];
			// eslint-disable-next-line array-callback-return
			response?.data.content.map((item: TmaritalStatus) => {
				items.push({
					label: item.name,
					value: item.id?.toString() || '0',
					data: item,
				});
			});
			setMaritalStatusList(items);
		}
	};

	const getDataProvinsi = async (keyword: string) => {
		const data = {
			keyword: keyword,
		};
		const response = await getProvinsi(data);
		if (!response?.error) {
			const items: Toption[] = [];
			// eslint-disable-next-line array-callback-return
			response?.data.map((item: Tprovinsi) => {
				items.push({
					label: item.provinsiName,
					value: item.id?.toString() || '0',
					data: item,
				});
			});
			setProvinsiList(items);
		}
	};

	const getDataCity = async (keyword: string, provinsiId: string) => {
		const data = {
			keyword: keyword,
			provinsiId: provinsiId,
		};
		const response = await getCity(data);
		if (!response?.error) {
			const items: Toption[] = [];

			// eslint-disable-next-line array-callback-return
			response?.data.map((item: Tcity) => {
				items.push({
					label: item.cityName,
					value: item.id?.toString() || '0',
					data: item,
				});
			});
			setCityList(items);
		}
	};

	const getDataDistrict = async (keyword: string, cityId: string) => {
		const data = {
			keyword: keyword,
			cityId: cityId,
		};
		const response = await getDistrict(data);
		if (!response?.error) {
			const items: Toption[] = [];
			// eslint-disable-next-line array-callback-return
			response?.data.map((item: Tdistrict) => {
				items.push({
					label: item.districtName,
					value: item.id?.toString() || '0',
					data: item,
				});
			});
			setDistrictList(items);
		}
	};

	const onSubmit = async () => {
		if (fullName.length < 6) {
			return showMessage('No Nama Lengkap Wajib Diisi', 'error');
		}

		if (email.length < 6) {
			return showMessage('No Email Wajib Diisi', 'error');
		}

		if (selectDistrict.data == null) {
			return showMessage('Alamat Belum Di isi dengan Benar', 'error');
		}

		if (!isValidPhoneNumber(phone)) {
			return showMessage('Format No Hp tidak sesuai ', 'error');
		}

		const data = {
			id: users.id,
			code: users.code,
			roles: users.roles,
			identityNumber1: users.identityNumber1,
			identityNumber2: users.identityNumber2,
			nickName: users.nickName,
			fullName: fullName,
			gender: gender,
			birthDate: birthDate.toUTCString(),
			placeOfBirth: placeOfBirth,
			memberType: users.memberType,
			email: email,
			userName: users.userName,
			maritalStatus: selectMaritalStatus.data,
			provinsi: selectProvinsi.data,
			city: selectCity.data,
			district: selectDistrict.data,
			address1: address1,
			address2: address2,
			phone: phone,
			password: password,
			joinDate: new Date().toUTCString(),
			reffCode: users.reffCode,
			block: false,
			register: false,
		};

		const response = await updateMyProfile(data);
		if (response?.code === 200) {
			navigate(`/admin/account`);
		} else {
			showMessage(response?.message, 'error');
		}
	};

	useEffect(() => {
		getDataProvinsi('');
		getDataMaritalStatus('');
		getMyDataProfile();
	}, []);

	return (
		<Layout
			title="Edit Profile"
			showNavBar={true}
			showNavigation={false}
		>
			<div className="mt-[70px]">
				<FormGroup label={'KTP'}>
					<InputTextblock
						readOnly
						value={users.identityNumber1}
						placeholder="No Induk Kependudukan"
					/>
				</FormGroup>
				<FormGroup label={'No KK'}>
					<InputTextblock
						readOnly
						value={users.identityNumber2}
						placeholder="No Kartu Keluarga"
					/>
				</FormGroup>
				<FormGroup label={'Nama Lengkap'}>
					<InputTextblock
						value={fullName}
						onChange={(e) => {
							setFullName(e.target.value);
						}}
						placeholder="Nama Lengkap"
					/>
				</FormGroup>
				<FormGroup label={'Jenis Kelamin'}>
					<div className="flex gap-2">
						<RadioButton
							value="male"
							checked={gender === 'male'}
							onChange={(e) => handleGenderChange(e.target.value)}
							label="Laki-laki"
						/>
						<RadioButton
							value="female"
							checked={gender === 'female'}
							onChange={(e) => handleGenderChange(e.target.value)}
							label="Perempuan"
						/>
					</div>
				</FormGroup>
				<FormGroup label={'Tempat Lahir'}>
					<InputTextblock
						value={placeOfBirth}
						onChange={(e) => setPlaceOfBirth(e.target.value)}
						placeholder="Tempat Lahir"
					/>
				</FormGroup>
				<FormGroup label={'Tanggal Lahir'}>
					<InputDate
						startDate={birthDate}
						onChange={(date: Date) => {
							setBirthDate(date);
						}}
					/>
				</FormGroup>
				<FormGroup label={'Status Pernikahan'}>
					<SelectDropDown
						options={maritalStatusList}
						value={selectMaritalStatus}
						onChange={(e) => {
							setSelectMaritalStatus(e);
						}}
						onInputChange={(e) => {
							getDataMaritalStatus(e);
						}}
					/>
				</FormGroup>
				<h2 className="text-[12px] font-bold mt-8 pb-2 border-b">Alamat</h2>
				<FormGroup label={'Provinsi'}>
					<SelectDropDown
						options={provinsiList}
						value={selectProvinsi}
						onChange={(e: Toption) => {
							setSelectProvinsi(e);
							if (e !== selectProvinsi) {
								setSelectCity(initialOption);
								setSelectDistrict(initialOption);
								getDataCity('', e.value);
								getDataDistrict('', '0');
							}
							getDataCity('', e.value);
						}}
						onInputChange={(e) => {
							getDataProvinsi(e);
						}}
					/>
				</FormGroup>
				<FormGroup label={'Kota'}>
					<SelectDropDown
						options={cityList}
						value={selectCity}
						onChange={(e) => {
							setSelectCity(e);
							if (e !== selectCity) {
								setSelectDistrict(initialOption);
								getDataDistrict('', e.value);
							}
						}}
						onInputChange={(e) => {
							getDataCity(e, selectProvinsi.value);
						}}
					/>
				</FormGroup>
				<FormGroup label={'Kecamatan'}>
					<SelectDropDown
						options={districtList}
						value={selectDistrict}
						onChange={(e) => {
							setSelectDistrict(e);
						}}
						onInputChange={(e) => {
							getDataDistrict(e, selectCity.value);
						}}
					/>
				</FormGroup>
				<FormGroup label={'Alamat KTP'}>
					<InputTextArea
						value={address1}
						onChange={(e) => setAddress1(e.target.value)}
						placeholder="Alamat"
					/>
				</FormGroup>
				<FormGroup label={'Alamat Domisili'}>
					<InputTextArea
						value={address2}
						onChange={(e) => setAddress2(e.target.value)}
						placeholder="Alamat"
					/>
				</FormGroup>
				<h2 className="text-[12px] font-bold mt-8 pb-2 border-b">Account</h2>
				<FormGroup label="Phone">
					<InputPhoneNumber
						onChage={(e) => setPhone(e)}
						value={phone}
					/>
				</FormGroup>
				<FormGroup label={'Email'}>
					<InputTextblock
						value={email}
						readOnly
						placeholder="Email"
					/>
				</FormGroup>
				<FormGroup label={'Password'}>
					<InputTextIcon
						value={password}
						onChange={(e) => {
							setPassword(e.target.value);
						}}
						placeholder="Password"
						type={!showPassword ? 'password' : 'text'}
						icon={!showPassword ? 'FaEyeSlash' : 'FaEye'}
						onClick={() => {
							setShowPassword(!showPassword);
						}}
					/>
				</FormGroup>
				<div className="my-8">
					<ButtonBlockPrimary
						onClick={() => {
							onSubmit();
						}}
						label="Simpan"
					/>
				</div>
			</div>
		</Layout>
	);
};

export default EditProfile;
